const About = () => {
  return <div>About page</div>
}

export { About }
